import { yupResolver } from '@hookform/resolvers/yup'
import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

export const useEditUserValidationSchema = () => {
	const { t } = useTranslation()

	const editUserValidationSchema = yup.object({
		email: yup.string().required(t('Email is required')),
		address: yup.object({
			address: yup.string().required(t('Address is required')),
			postal_code: yup.string().required(t('Postal code is required')),
			city: yup.string().required(t('City is required'))
		})
	})

	return yupResolver(editUserValidationSchema)
}
